/* Black Fireplace - collection grid ordering
   - sold-out units always sink below available ones, across every results page
   - adds a "Largest saving" sort (biggest % off the compare-at price, then the biggest dollar saving)
   - trims the sort menu to the options shoppers use */
(() => {
  const SORTS = [
    ['manual', 'Featured'],
    ['best-selling', 'Most popular'],
    ['bf-saving', 'Largest saving'],
    ['price-ascending', 'Price, lowest first'],
    ['price-descending', 'Price, highest first'],
    ['created-descending', 'Recently added']
  ];
  let ticket = 0;

  const query = () => {
    const prev = window.FacetFiltersForm && typeof FacetFiltersForm.searchParamsPrev === 'string'
      ? FacetFiltersForm.searchParamsPrev : location.search.slice(1);
    return new URLSearchParams(prev);
  };
  const activeSort = (grid) => query().get('sort_by') || (grid && grid.dataset.sortDefault) || 'manual';

  const rebuildMenus = (sort) => {
    document.querySelectorAll('select[name="sort_by"]').forEach((menu) => {
      if (menu.dataset.bfSorted === sort) return;
      const known = {};
      [...menu.options].forEach((o) => { known[o.value] = o.textContent.trim(); });
      const list = SORTS.slice();
      if (!list.some(([v]) => v === sort)) list.push([sort, known[sort] || sort]);
      menu.replaceChildren(...list.map(([value, label]) => {
        const opt = new Option(label, value, value === sort, value === sort);
        return opt;
      }));
      menu.value = sort;
      menu.dataset.bfSorted = sort;
    });
  };

  const n = (el, key) => Number(el.dataset[key]) || 0;
  const order = (cards, sort) => {
    cards.forEach((c, i) => { c._bfPos = i; });
    return cards.sort((a, b) => {
      const stock = (b.dataset.available === 'true') - (a.dataset.available === 'true');
      if (stock) return stock;
      if (sort === 'bf-saving') {
        const pct = n(b, 'offPct') - n(a, 'offPct');
        if (pct) return pct;
        const amt = n(b, 'offAmt') - n(a, 'offAmt');
        if (amt) return amt;
      }
      return a._bfPos - b._bfPos;
    });
  };

  const reveal = (grid) => grid.classList.remove('bf-grid-pending');

  const apply = async () => {
    const grid = document.getElementById('product-grid');
    if (!grid) return;
    const sort = activeSort(grid);
    rebuildMenus(sort);
    const mine = ++ticket;
    const pages = parseInt(grid.dataset.pageCount, 10) || 1;

    if (pages < 2) {
      const cards = [...grid.querySelectorAll(':scope > li.grid__item[data-handle]')];
      if (sort === 'bf-saving' && cards.length > 1) order(cards, sort).forEach((c) => grid.append(c));
      reveal(grid);
      return;
    }

    const size = parseInt(grid.dataset.pageSize, 10) || 24;
    const now = parseInt(grid.dataset.pageNow, 10) || 1;
    const base = query();
    const urls = Array.from({ length: pages }, (_, i) => {
      const p = new URLSearchParams(base.toString());
      p.set('page', i + 1);
      p.set('section_id', grid.dataset.id);
      return `${location.pathname}?${p}`;
    });

    try {
      const bodies = await Promise.all(urls.map((u) => fetch(u, { credentials: 'same-origin' }).then((r) => r.text())));
      if (mine !== ticket) return;
      const dom = new DOMParser();
      const seen = new Set();
      const all = [];
      bodies.forEach((html) => {
        dom.parseFromString(html, 'text/html').querySelectorAll('#product-grid > li.grid__item[data-handle]').forEach((li) => {
          if (li.dataset.handle && !seen.has(li.dataset.handle)) { seen.add(li.dataset.handle); all.push(li); }
        });
      });
      const slice = order(all, sort).slice((now - 1) * size, now * size);
      if (slice.length) grid.replaceChildren(...slice);
    } catch (err) {
      console.warn('[bf] grid ordering skipped', err);
    } finally {
      if (mine === ticket) reveal(grid);
    }
  };

  if (window.FacetFiltersForm && !FacetFiltersForm._bfHooked) {
    const render = FacetFiltersForm.renderProductGridContainer;
    FacetFiltersForm.renderProductGridContainer = function (html) { render.call(FacetFiltersForm, html); apply(); };
    FacetFiltersForm._bfHooked = true;
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', apply) : apply();
})();
